// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"048e5d5b","239":"cb6eabc8","453":"6e7705dd","455":"19d03ca3","510":"2db53ee3","832":"bd21704d","977":"ddc3bff2","981":"63f5fb16"}[chunkId] + ".chunk.js";
};